
<section class="ui_ctmenu" :style="style" :class="{'paddingModify': state.showMenu}" @mouseleave="state.showMenu = false"  @contextmenu.prevent="return">
  <!-- @mouseleave="state.showMenu = false" -->
  <div class="contextmenu"  v-if="state.showMenu" v-click-outside="handleFocusOut">
    <div :id="'GTM'+each.gtmId" class="contextmenu_each GTMClass_preventPointerEvent GTM__Context" v-for="(each, i) in list" @click.stop="selectContextMenu(each)" >
      <div :class="{'disable': each.disabled}">{{each.isI18n ? t(each.isI18n) : each.title}}</div>
    </div>
  </div>
</section>